import Bubble from "./Bubble";
import List from "./BubbleList";
Bubble.List = List;
export default Bubble;